import {ALIGNMENT, VERTICAL_ALIGNMENT, WIDGET_LAYOUT} from '@wix/wix-events-commons-statics'

export const getAlignmentClassName = (alignment: number) => getClassName(ALIGNMENT, alignment)

export const getVerticalAlignmentClassName = (alignment: number) => {
  const className = getClassName(VERTICAL_ALIGNMENT, alignment)
  return className === 'center' ? 'middle' : className
}

export const getLayoutClassName = (layout: number) => getClassName(WIDGET_LAYOUT, layout)

const getClassName = (property: object, value: number) =>
  Object.entries(property)
    .find(([_key, val]) => val === value)?.[0]
    .toLowerCase()
